<ng-template #newTaskTemplate>
	<mod-task-form (create)="handleCreateTask($event)" [isInDialog]="true"></mod-task-form>
</ng-template>

@if (enableEdit()) {
<div class="push-bottom">
	<lib-button-list [buttons]="mainButtons()"></lib-button-list>
</div>

<lib-message class="push-bottom" [type]="'tip'" [title]="'Stay on Track with Tasks'" [dismissId]="'taskManagementInfo'">
	<p>
		The <strong>Tasks</strong> feature lets you assign specific action items to your clients — helping them stay
		focused, accountable, and organized.
	</p>

	<p>You can create custom tasks for anything, such as:</p>
	<ul>
		<li>“Take progress photos”</li>
		<li>“Walk 5 000 steps”</li>
		<li>“Complete wellness check-in”</li>
		<li>“Complete 10 minutes of mobility exercises”</li>
	</ul>

	<p>All tasks you assign will appear on your client’s dashboard, so they always know what to do next.</p>

	<p>💡 Use tasks to keep coaching clear and structured — both inside and outside of workouts.</p>
</lib-message>
} @if (assignedTasksListItems(); as assignedTasksListItems) {

<lib-card>
	<lib-list
		[noItemsText]="authUserIsClient() ? 'You have no assigned tasks' : 'Client has no assigned tasks'"
		[items]="assignedTasksListItems"
	></lib-list>
</lib-card>
} @else {
<lib-message [icon]="'task'" [type]="'noDataOnBody'"
	>@if (authUser()?.userType === 'client') {
	<span>You have no assigned tasks.</span>
	} @else {
	<span>Client has no tasks assigned</span>
	}</lib-message
>
}
